import { ETripEvent } from '../../../../../../../../../../../detailsv2/structure';

export const DEFAULT_ICONS = {
  [ETripEvent.Accommodation]: [
    'fa-kit fa-defaulticon-accommodation',
    'fa-bell-concierge fa-classic fa-light',
    'fa-hotel fa-classic fa-light',
    'fa-snooze fa-classic fa-light',
    'fa-suitcase fa-classic fa-light',
    'fa-light fa-tents',
    'fa-light fa-tent',
  ],
  [ETripEvent.Area]: [
    'fa-light fa-location-dot',
    'fa-kit fa-defaulticon-area',
    'fa-light fa-map-pin',
    'fa-earth-africa fa-classic fa-light',
    'fa-globe-stand fa-classic fa-light',
    'fa-compass fa-classic fa-light',
    'fa-map fa-classic fa-light',
  ],
  [ETripEvent.Activity]: [
    'fa-kit fa-defaulticon-activity',
    'fa-puzzle-piece fa-classic fa-light',
    'fa-kit fa-noun-binoculars',
    'fa-kit fa-noun-safari-hat',
    'fa-utensils fa-classic fa-light',
    'fa-person-hiking fa-classic fa-light',
    'fa-light fa-handshake',
  ],
  [ETripEvent.Flight]: [
    'fa-light fa-plane',
    'fa-kit fa-defaulticon-flight',
    'fa-plane-up fa-sharp fa-light',
    'fa-light fa-plane-departure',
    'fa-light fa-plane-arrival',
    'fa-helicopter fa-classic fa-light',
    'fa-light fa-route',
    'fa-light fa-ticket-airline',
  ],
  [ETripEvent.Information]: [
    'fa-kit fa-defaulticon-information',
    'fa-triangle-exclamation fa-classic fa-light',
    'fa-note-sticky fa-classic fa-light',
    'fa-star fa-classic fa-light',
    'fa-comment fa-classic fa-light',
    'fa-clipboard fa-classic fa-light',
  ],
  [ETripEvent.Transfer]: [
    'fa-light fa-car',
    'fa-light fa-taxi',
    'fa-kit fa-defaulticon-transfer',
    'fa-light fa-road',
    'fa-train fa-classic fa-light',
    'fa-helicopter fa-classic fa-light',
    'fa-ship fa-classic fa-light',
    'fa-light fa-route',
  ],
};
